import { BrandMark } from "../components/ui/BrandMark";

export function SetupRequiredScreen() {
  return (
    <div className="app-shell">
      <header className="site-header">
        <div className="site-header-inner">
          <span className="brand">
            <BrandMark size={26} />
            <span className="brand-name">woven</span>
          </span>
        </div>
      </header>
      <main id="main" className="site-main">
        <div className="page page--narrow">
          <section className="panel" role="alert">
            <h1 className="panel-title">Firebase is not configured</h1>
            <p className="page-prose">
              This app needs environment variables to initialize Firebase. Copy{" "}
              <code>apps/web/.env.example</code> to <code>apps/web/.env</code> and fill in the
              values (emulator defaults work out of the box with <code>npm run dev:emulators</code>
              ).
            </p>
            <p className="page-prose form-note">
              No secrets are required in the repository, and no values are hardcoded.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
